"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _appointmentHistory = require("@/api/appointmentHistory/appointmentHistory");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "confirmPrintingDialog",
  components: {
    Pagination: _index.default,
    dragDialog: _DragDialog.default
  },
  props: {
    formDialog: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabledType: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fileList: [],
      poolTypeList: [],
      listQuery: {
        currentPage: 1,
        pageSize: 10
      },
      total: 0,
      tableData: [],
      loading: null,
      form: {
        blNo: '',
        appointmentStatus: '',
        deliveryOrderType: '',
        paymentStatus: '',
        paymentMethod: '',
        paymentTitle: '',
        taxpayerIdentificationNumber: '',
        address: '',
        invoiceTitleTaxNumber: '',
        invoiceTitleAccount: '',
        poolType: '',
        masterDataCode: '',
        imoNo: '',
        builderName: '',
        authorizationStatus: '',
        authorizedCustomer: ''
      },
      hotSettings: {
        dragCheck: true,
        height: 'calc(50vh - 215px)',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {},
  methods: {
    opened: function opened() {},
    //关闭
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    //上一步
    handlePreviousStep: function handlePreviousStep() {
      this.$emit('handlePreviousStep');
    },
    //确认并打印rowData.bookingHeadId,rowData.eta,rowData.blNo,rowData.del
    handleConfirmPrint: function handleConfirmPrint() {
      var _this = this;
      this.loading = (0, _utils.load)();
      (0, _appointmentHistory.downDocReleaseOrder)(this.formDialog.bookingHeadIds, this.formDialog.eta, this.formDialog.blNo, this.formDialog.del).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res], {
          type: 'application/pdf'
        }));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', 'doc_release_order_ph.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).finally(function () {
        _this.loading.close();
      });
    },
    handlePageChange: function handlePageChange() {},
    closed: function closed() {}
  }
};